import ContainerRoutes from "../quality_reports/container";
import ContainerProviderRoutes from "../quality_reports/container_provider";
import ProcessByMainRepRoutes from "./process_by_main_rep";
import ProcessRoutes from "./process";

export default [
  ...ContainerRoutes,
  ...ContainerProviderRoutes,
  ...ProcessByMainRepRoutes,
  ...ProcessRoutes,
];
